module.exports = __webpack_public_path__ + "img/矩形 82@1x.babb3e6c.png";